import { Lottie, LottieOptions } from '@rhg/libs/lottie-react';
import infoDark from '@rhg/libs/lottie-react/animations/info-dark';
import infoLight from '@rhg/libs/lottie-react/animations/info-light';
import { Box, useTheme } from '@rhg/libs/material';
import { useMemo } from 'react';

export const INFO_ANIMATION_SIZE_MOBILE = 64;
export const INFO_ANIMATION_SIZE_DESKTOP = 96;

const styleWrapper = {
    width: {
        xs: INFO_ANIMATION_SIZE_MOBILE,
        sm: INFO_ANIMATION_SIZE_MOBILE,
        md: INFO_ANIMATION_SIZE_DESKTOP,
    },
    height: {
        xs: INFO_ANIMATION_SIZE_MOBILE,
        sm: INFO_ANIMATION_SIZE_MOBILE,
        md: INFO_ANIMATION_SIZE_DESKTOP,
    },
};

export function InfoAnimation() {
    const {
        palette: { mode },
    } = useTheme();

    const options = useMemo<LottieOptions>(
        () => ({
            animationData: mode === 'dark' ? infoDark : infoLight,
            autoplay: true,
            loop: false,
        }),
        [mode]
    );

    return (
        <Box sx={styleWrapper}>
            <Lottie {...options} />
        </Box>
    );
}
